exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Body-module__wrapper___2Lqw2{display:grid;gap:1.5rem}@media screen and (min-width:768px){.Body-module__wrapper___2Lqw2{grid-template-columns:.6fr .4fr;gap:6rem}}", ""]);

// exports
exports.locals = {
	"wrapper": "Body-module__wrapper___2Lqw2"
};